import React, { Component } from "react"
import Headroom from "react-headroom"
import { Flex, Image, Box } from "rebass"
import styled from "styled-components"
import propTypes from "prop-types"
import { Link } from "gatsby"
import Fade from "react-reveal/Fade"

import withTranslation from "../i18n/withTranslation"
import LanguageSwitch from "./LanguageSwitch"
import logoBlack from "../assets/logoBalmaceda.svg"
import RouteLink from "./RouteLink"
import HamburgerButton from "./HamburgerButton"

const HeaderContainer = styled(Headroom)`
  position: relative;
  width: 100%;
  z-index: 2;

  .headroom--pinned {
    background: #fff;
    padding-bottom: 40px;
    > div {
      padding: 2px 0;
      > div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        @media screen and (max-width: 769px) {
          flex-direction: column;
        }
      }
    }

    .logo {
      padding-left: 40px;
    }

    img {
      margin-top: 32px;
      width: 220px;
    }

    .header-link {
      justify-content: space-around;

      a {
        padding-left: 20px;
        font-size: 0.6em;
      }

      @media only screen and (min-width: 768px) and (max-width: 991px) {
        a {
          font-size: 0.6em;
          padding-left: 20px;
        }
      }

      @media only screen and (min-width: 992px) {
        a {
          font-size: 0.8em;
          padding-left: 40px;
        }
      }
    }
  }
`

const StyledHamburger = styled(Box)`
  position: relative;
  display: none;

  @media screen and (max-width: 639px) {
    display: block !important;
  }
`

const FlexMenu = styled(Flex)`
  margin: 0 auto;

  @media screen and (max-width: 639px) {
    border-width: 1px 0 1px 0;
    border-color: #000000;
    border-style: solid;
    max-height: 0;
    overflow: hidden;
    display: none !important;

    &.toggled {
      max-height: 1500px;
      transition: max-height 1s;
      display: flex !important;
    }
  }
`

const isActive = ({ isCurrent }) => {
  return isCurrent ? { className: "active" } : null
}

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menuClass: "",
    }
  }

  setToggleMenu = () => {
    const { menuClass } = this.state

    if (menuClass === "") {
      this.setState({
        menuClass: "toggled",
      })
    } else {
      this.setState({
        menuClass: "",
      })
    }
  }

  render = () => {
    const { menuClass } = this.state
    const { t } = this.props

    return (
      <HeaderContainer>
        <Fade top>
          <Flex
            flexDirection="column"
            alignItems="center"
            sx={{ background: "white" }}
          >
            <Link to="/" className="logo">
              <Image
                src={logoBlack}
                width={["300px", "250px"]}
                mt={[4, 5]}
                style={{
                  cursor: "pointer",
                }}
              />
            </Link>
            <StyledHamburger className="hamburger" p={[4, 3]}>
              <HamburgerButton toggleMenu={this.setToggleMenu} />
            </StyledHamburger>
            <FlexMenu
              width={[1, 1, 7 / 8, 7 / 8]}
              flexDirection={["column", "row"]}
              justifyContent={["center", "space-between"]}
              alignItems="center"
              p={3}
              pt={[0, 3]}
              pb={[4, 3]}
              className={`${menuClass} header-link`}
            >
              <RouteLink>
                <Link getProps={isActive} to="/bespoke">
                  {t("header.bespoke")}
                </Link>
              </RouteLink>
              <RouteLink>
                <Link getProps={isActive} to="/collections">
                  {t("header.collections")}
                </Link>
              </RouteLink>
              <RouteLink>
                <Link getProps={isActive} to="/installations">
                  {t("header.installations")}
                </Link>
              </RouteLink>
              <RouteLink>
                <Link getProps={isActive} to="/team">
                  {t("header.team")}
                </Link>
              </RouteLink>
              <RouteLink>
                <Link getProps={isActive} to="/blog">
                  {t("header.blog")}
                </Link>
              </RouteLink>
            </FlexMenu>
            <LanguageSwitch className="switch" />
          </Flex>
        </Fade>
      </HeaderContainer>
    )
  }
}

Header.propTypes = {
  t: propTypes.func.isRequired,
}

export default withTranslation(Header)
